'use client'

import { produce } from 'immer'
import { useRouter, usePathname, useSearchParams } from 'next/navigation'

import { BodyObjectView } from 'utility/utility'
import { SpeakerFeaturedFragment } from 'generated/graphql'
import { EventFilters } from './EventFilters'

export const SpeakerFilterList: BodyObjectView<{
    speakers: readonly [SpeakerFeaturedFragment,React.ReactNode][],
    events: string[],
    showMenuBar: boolean | null
}> =
    ({
        speakers,
        events,
        showMenuBar
    }) => {

        const router = useRouter()
        const pathname = usePathname()
        const searchParams = useSearchParams()

        const updateQuery = (
            value: string
        ): void => {
            const field = "event"
            const params = produce(Object.fromEntries(searchParams.entries()), draft => {
                if ( value === 'all' || value === searchParams.get(field) ) {
                    delete draft[field]
                }
                else {
                    draft[field] = value
                }
            })
            const query = new URLSearchParams([...Object.entries(params)])
            router.replace(
                `${pathname}${ query.size === 0 ? '' : `?${query.toString()}` }`,
                { scroll: false }
            )
        }

        const event = searchParams.get('event')

        return (
            <>
                {events.length > 1 && (showMenuBar === null || showMenuBar) ? <EventFilters value={event} events={events} onChange={updateQuery} /> : <></>}
                <ul data-number={speakers.length}>
                    {
                        speakers
                            .map(
                                ([speaker,speakerFeatured], index) =>
                                      speaker === null ? <></>
                                    : speaker === undefined ? <></>
                                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                    : event !== null && !speaker.events?.data.map(event => event.attributes?.title).includes(event) ? <></>
                                    :   <li key={`${speaker.name}-${index}`}>
                                            { speakerFeatured }
                                        </li>
                            )
                    }
                </ul>
            </>
        )

    }

